<template>
    <custom-node variant="full" :handles="[{ type: 'source', position: Position.Bottom }]">
        <template #icon>
            <svg-icon
                class="node-icon"
                :icon="IconFaceParty"
                color="#f7c91a"
                is-custom-icon
            />
        </template>

        <template #content>
            <flex-container>
                <h2>Startpunt</h2>
                <span v-if="false" v-tooltip.info="'Lorem ipsum'">
                    <svg-icon
                        :icon="IconCircleInfo"
                        is-custom-icon
                    />
                </span>
            </flex-container>
            <p>{{ description }}</p>
        </template>
    </custom-node>
</template>

<script setup lang="ts">
    import { FlexContainer, SvgIcon } from '@keyvue/one-ui';
    import { computed } from 'vue';
    import { Position } from '@vue-flow/core';
    import type { Trigger } from '@keyvue/one-api-client';
    import CustomNode from '@/flow/flow/components/graph/custom-types/CustomNode.vue';

    import IconFaceParty from '@keyvue/one-awesome-icons/icons/regular/face-party.svg?component';
    import IconCircleInfo from '@keyvue/one-awesome-icons/icons/regular/circle-info.svg?component';

    interface Props {
        data: Trigger
    }

    const props = defineProps<Props>();

    const description = computed(() => {
        const timingType = props.data.options?.timingType;
        const timingQuantity = props.data.options?.timingQuantity ?? '-';
        const timingUnit = props.data.options?.timingUnit ?? '-';

        switch (timingType) {
            case 'on': return 'Op de verjaardag van een contactpersoon';
            case 'before': return `${timingQuantity} ${timingUnit} voor de verjaardag van een contactpersoon`;
            case 'after': return `${timingQuantity} ${timingUnit} na de verjaardag van een contactpersoon`;
            default: return 'Wanneer een contactpersoon jarig is';
        }
    });
</script>

<style scoped lang="scss">
.custom-node {
    :deep(.custom-node__container) {
        background-color: #f7c91a;
        &[selected="false"] {
            &:hover {
                background-color: #ED6E2D;

                :deep(.node-icon) {
                    color: #ED6E2D;
                }
            }
        }
    }
}
</style>
